import { createSelector } from 'reselect';

import type { RootState } from '../store/store';

const selectRateConversation = (state: RootState) => state.rateConversation;

export const selectRate = createSelector([selectRateConversation], (rateConversation) => rateConversation.rate);

export const selectRateHover = createSelector(
  [selectRateConversation],
  (rateConversation) => rateConversation.rateHover
);

export const selectRateConversationStatus = createSelector(
  [selectRateConversation],
  (rateConversation) => rateConversation.conversationStatus
);

export const selectIsRateConversationOpen = createSelector(
  [selectRateConversation],
  (rateConversation) => rateConversation.isOpen
);
